// extracted by mini-css-extract-plugin
export default {"root":"shortRegistrationForm__root__C1NX7","grid":"shortRegistrationForm__grid__gxSgD","error":"shortRegistrationForm__error__uaj5Y"};